import dayjs from "dayjs";
import { useCallback } from "react";

import { useAppSelector } from "@/hooks/redux";

import { TIME_INTERVALS } from "../constants";

export const useScheduleStatus = (userId: string, isActive: boolean) => {
    const { activeSchedule, lastUpdated } = useAppSelector((state) => state.sv);

    const hasSchedule = useCallback(() => {
        if (
            !activeSchedule ||
            !lastUpdated.activeSchedule ||
            dayjs(lastUpdated.activeSchedule).isBefore(
                dayjs().subtract(TIME_INTERVALS.SCHEDULE_EXPIRY_DAYS, "day"),
            )
        ) {
            return false;
        }

        return activeSchedule === userId;
    }, [activeSchedule, lastUpdated.activeSchedule, userId]);

    const canAccess = isActive;

    return {
        hasSchedule: hasSchedule(),
        canAccess,
    };
};
